import { useEligibleForTwcg1935CodingAgentChoice } from '@/components/user-context/helpers/cohorts.ts';
import { experiments } from '@/utils/experiment/manifest.ts';
import { getExperiment, useExperiment } from '@/utils/experiment/use-experiment.ts';

import {
	useEligibleForGenericSampleData,
	useEligibleForSampleTasksForLandingGateNonTech,
} from '../controllers';
import { WizardTemplateOption } from '../utils/types';

export type ExperimentKeys = keyof typeof experiments;

export const useIsJFindInviteStepExperiment = () => {
	const jfindInviteStepExperimentConfig = getExperiment(
		experiments.jfindOnboardingWizardInviteStep,
	);
	return (
		jfindInviteStepExperimentConfig.type === 'enrolled' && jfindInviteStepExperimentConfig.value
	);
};

export const useIsGenericSampleData = (template: WizardTemplateOption) => {
	const { userEligibleForGenericSampleData } = useEligibleForGenericSampleData(template);

	return {
		genericSampleDataIsEnabled: userEligibleForGenericSampleData,
	};
};

export const useIsSampleTasksForLandingGateNonTech = () => {
	const sampleTasksForLandingGateNonTechExperimentConfig = useExperiment(
		experiments.jfindSampleTasksForLandingGateNonTech,
	);

	const { userEligibleForSampleTasksForLandingGateNonTech } =
		useEligibleForSampleTasksForLandingGateNonTech();

	if (!userEligibleForSampleTasksForLandingGateNonTech) {
		return {
			sampleTasksForLandingGateNonTechIsEnrolledInTest: false,
			sampleTasksForLandingGateNonTechFireExposure: undefined,
		};
	}

	const sampleTasksForLandingGateNonTechIsEnrolled =
		sampleTasksForLandingGateNonTechExperimentConfig.type === 'enrolled';

	const sampleTasksForLandingGateNonTechFireExposure = sampleTasksForLandingGateNonTechIsEnrolled
		? sampleTasksForLandingGateNonTechExperimentConfig.fireExposure
		: undefined;

	return {
		sampleTasksForLandingGateNonTechIsEnrolledInTest:
			sampleTasksForLandingGateNonTechIsEnrolled &&
			sampleTasksForLandingGateNonTechExperimentConfig.value,
		sampleTasksForLandingGateNonTechFireExposure,
	};
};

export const useIsCodingAgentChoice = () => {
	const codingAgentChoiceExperimentConfig = useExperiment(experiments.twcg1935CodingAgentChoice);

	const userEligibleForCodingAgentChoice = useEligibleForTwcg1935CodingAgentChoice();

	if (!userEligibleForCodingAgentChoice) {
		return {
			codingAgentChoiceIsEnrolledInTest: false,
		};
	}

	const codingAgentChoiceIsEnrolled = codingAgentChoiceExperimentConfig.type === 'enrolled';

	// Exposure is fired automatically by the SDK (manifest
	// `fireExperimentExposure: true`), so we don't return a manual fire.
	return {
		codingAgentChoiceIsEnrolledInTest:
			codingAgentChoiceIsEnrolled && codingAgentChoiceExperimentConfig.value,
	};
};
